import { __awaiter, __generator } from "tslib";
import { setImageUrlFromFile } from "./setImageUrlFromFile";
import { performFileUpload } from "../serviceUtils";
function _emitSignature(message, color) {
    console.log(message, color);
    return undefined;
}
function uploadFileSignature(data, options) {
    console.log(data, options);
}
function setValueSignature(name) {
    console.log(name);
}
export function uploadFile(data, options) {
    var _this = this;
    var _emit = options._emit, genericApiService = options.genericApiService, imageUrlStatePath = options.imageUrlStatePath, loaderStatePath = options.loaderStatePath, onErr = options.onErr, onProgress = options.onProgress, s3KeyStatePath = options.s3KeyStatePath, setValue = options.setValue, fileNameStatePath = options.fileNameStatePath, setStateValue = options.setStateValue, uploadCb = options.uploadCb;
    return (function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
        var s3Key, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (loaderStatePath) {
                        dispatch(setStateValue({ key: loaderStatePath, value: true }));
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4, performFileUpload(data, { onProgress: onProgress })];
                case 2:
                    s3Key = (_a.sent()).key;
                    if (setValue) {
                        setValue(s3Key);
                    }
                    else if (s3KeyStatePath) {
                        dispatch(setStateValue({ key: s3KeyStatePath, value: s3Key }));
                    }
                    if (fileNameStatePath) {
                        dispatch(setStateValue({ key: fileNameStatePath, value: data.file.name }));
                    }
                    if (imageUrlStatePath && genericApiService) {
                        dispatch(setImageUrlFromFile({
                            imageKey: s3Key,
                            imageUrlStatePath: imageUrlStatePath
                        }, { _emit: _emit, genericApiService: genericApiService, setStateValue: setStateValue }));
                    }
                    return [3, 4];
                case 3:
                    e_1 = _a.sent();
                    console.error(e_1);
                    dispatch(_emit("Error during upload", "error"));
                    if (onErr) {
                        onErr();
                    }
                    return [3, 4];
                case 4:
                    uploadCb && uploadCb();
                    if (loaderStatePath) {
                        dispatch(setStateValue({ key: loaderStatePath, value: false }));
                    }
                    return [2];
            }
        });
    }); });
}
//# sourceMappingURL=uploadFile.js.map